<template>
    <section id="letter_edit">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header col-md-6">
                        <h4 class="card-title">Preview</h4>
                        <a href="#" @click="backUrl()">Back</a>
                    </div>
                    <div class="card-content">
                        <div class="card-body">
                            <template v-if="isLoaded">
                                <div class="row">
                                    <div class="col-12">
                                        <h4>APPEND CLIENT DOCUMENTS</h4>
                                        <div class="display-box mb-1">
                                            <div class="ml-2">
                                                <input
                                                    class="custom-control-input"
                                                    type="checkbox"
                                                    name="append_affidavit"
                                                    value="1"
                                                    tabindex="4"
                                                    v-model="checkbox"
                                                    id="append_affidavit"

                                                />
                                                <label class="custom-control-label" for="Make_the_recipient_the_sender" @click="changeCheckbox">
                                                    ID Theft Affidavit
                                                </label>
                                            </div>

                                        </div>

                                    </div>
                                </div>

                                <form>
                                    <editor
                                        id="letterPreview"
                                        v-model="letterPreview"
                                        :api-key="settingStore.tinymce.api_key"
                                        :init="settingStore.tinymce.configuration"
                                    />
                                    <div class="d-flex my-1">
                                        <!-- add .once and uncomment key++ -->
                                        <button class="px-1 btn-outline-primary" @click="uploadDocuments" type="button" name="upload_document" value="1" style="height: 32px;">
                                            <vue-feather type="upload" class="text-primary" size="14"></vue-feather>
                                            {{ localizationStore.translate("upload.file.btn") }}
                                        </button>
                                        <div class="custom-file" hidden>
                                            <input type="file" class="custom-file-input" id="letter_document"  @change="selectedDocument" ref="uploadDocument"/>
                                            <label class="custom-file-label label-green" for="letter_document">Choose Logo</label>
                                        </div>
                                        <div class="d-flex">
                                            <div class="uploaded-document px-1 btn-outline-primary" style="height: 32px;" v-for="(document,index) in letter.documents" :key="index">
                                                <span class="file_doc" @click="previewDocument(document)">{{document.name}}</span>
                                                <!-- <span class="file_download" style="padding-left:6px;cursor:pointer;" @click="downloadFile(document.url)">
                                                    <vue-feather type="download" class="text-primary" size="14"></vue-feather>

                                                </span> -->
                                                <span class="file_delete" style="padding-left:6px;cursor:pointer;">
                                                    <vue-feather type="trash" class="text-warning" size="14" @click="deleteDocument(index,document.id)"></vue-feather>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="saving-document d-flex mx-1">
                                            {{isSavingInfo}}
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-left my-1">
                                        <button
                                            class="btn btn-sm-block btn-outline-primary mr-1"
                                            type="button"
                                            @click="spinLetter"
                                        >
                                            {{ localizationStore.translate('letter.edit.button.one') }}
                                        </button>
                                        <button class="btn btn-sm-block btn-outline-primary" type="button" @click-once="updateLetter">
                                            {{ localizationStore.translate('letter.edit.button.two') }}
                                        </button>
                                    </div>
                                </form>
                            </template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <document-preview
            :id="'previewLetterMedia'"
            :type="activeMedia.mime_type"
            :url="activeMedia.url"
            v-if="activeMedia"
        />
    </section>

</template>
<script>
  import axios from 'axios';
  import { reactive, computed, ref} from 'vue'
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  import { useSettingStore } from '../../stores/SettingStore.js'
  import { useUserStore } from '../../stores/UserStore.js'
  import { useSpinStore } from '../../stores/SpinStore.js'
  import Swal from 'sweetalert2'
  import Editor from '@tinymce/tinymce-vue'
  import lodash from 'lodash'
  import DocumentPreview from '../modals/DocumentPreview.vue'
  import { openModal } from '../../utilities/_helpers'
  export default {
    props: {},
    components: {
        Editor,
        DocumentPreview
    },
    setup(props) {

        return {
            editorRef: ref(null),
            backUrl:ref(null),
            localizationStore: useLocalizationStore(),
            settingStore: useSettingStore(),
            userStore: useUserStore(),
            spinStore: useSpinStore(),
            letterPreview: ref(props.letterPreview),
            checkbox:ref(false),
            isLoaded:ref(false),
            lodash: lodash,
            document:ref(),
            originalFile:ref([]),
            isSavingInfo:ref(''),
            letter:ref([]),
            activeMedia:ref(),
            openModal:openModal
        };
    },
    created() {
    },
    mounted() {
        if (_.isNull(useSettingStore().setting)) {
            useSettingStore().fetchSetting();
        }
        this.getLetterContent();
    },
    computed: {
    },
    methods: {
        backUrl(ur){
            let $this = this;
            if($this.userStore.user.isDIY){
                $this.$router.push({ name: 'diy-dashboard' });
                return;
            }
            window.location.href = this.backUrl;
        },
        spinLetter()
        {
            let $this = this;
            if (!$this.spinStore.isValidCountCharater('letterPreview', '.letter-content')) {
                toastr.error(`Cannot Spin more than ${this.spinStore.maxCharaterAllowed}`, 'Error!');
                return;
            }
            let content = $this.spinStore.getContent('letterPreview', '.letter-content'),
            selectedSeparator = $this.spinStore.getSeparator('letterPreview', '.letter-content');
            Swal.fire({
                title: `${this.localizationStore.translate("spin.letter.popup.title")}`,
                html: `<span class="spinner-border spinner-border-sm  mr-50" role="status" aria-hidden="true"></span> ${this.localizationStore.translate("spin.letter.popup.message")}`,
                showConfirmButton: false,
                allowOutsideClick: false,
                willOpen: function (sweetalert) {
                    sweetalert.querySelector('.swal2-html-container')
                        .classList
                        .add('d-flex', 'align-items-center', 'justify-content-center');
                }
            });
            const spinLetterRoute = $this.$router.resolve({name:'spin-letter'}).href;
            axios.post(
                spinLetterRoute,
                {
                    content: content,
                    tags: []
                }
            )
            .then(function (response) {
                Swal.close();
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                $this.userStore.user.balance = response.data.data.balance;
                const updatedContents = response.data.data.content.split(selectedSeparator);
                tinymce.get('letterPreview').dom.select('.letter-content').forEach((element, index) => {
                    element.innerHTML = updatedContents[index];
                });
            })
            .catch(function (error) {
                Swal.close();
                toastr.error(error.message, 'Error!');
            });
        },
        getLetterContent(){
            let $this = this;
            let params = {
                letter: $this.$route.params.letter_user
            };
            const editDisputeLetter = $this.$router.resolve({
                name: 'preview-dispute-letter',
                params: params
            });
            axios.get(editDisputeLetter.href)
            .then(response => {
                $this.letter = response.data.data;
                $this.letterPreview = response.data.data.letter_preview;
                $this.activeMedia = $this.letter.documents[0]
                if(response.data.data.append_affidavit){
                    $this.checkbox = response.data.data.append_affidavit ? true : false
                }

                $this.backUrl = response.data.data.url;
                $this.isLoaded = true
            });
        },
        updateLetter(){
            let $this = this;
            let params = {
                letterUser: $this.$route.params.letter_user
            };
            if ($this.$route.params.client) {
                params.client = $this.$route.params.client
            }
            if ($this.$route.params.team) {
                params.team = $this.$route.params.team
            }
            const updateDisputeLetter = $this.$router.resolve({
                name: 'letter-edit',
                params: params
            });
            const payload = {
                editor:this.letterPreview,
                has_affidavit: this.checkbox
            };
            axios.post(updateDisputeLetter.href,payload)
            .then(response => {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                setTimeout(() => {
                    if($this.userStore.user.isDIY){
                        $this.$router.push({ name: 'diy-dashboard' });
                        return;
                    }
                    window.location.href = response.data.data;
                }, 3000)
            });
        },
        changeCheckbox(){
            this.checkbox = !this.checkbox
        },
        uploadDocuments(){
            this.$refs.uploadDocument.click();
        },
        selectedDocument(e) {
            e.preventDefault();
            const file = e.target.files[0];
            this.originalFile = file
            this.document = URL.createObjectURL(file);
            console.log(this.lodash.isEmpty(this.originalFile) || !this.lodash.isNull(this.originalFile))
            if(this.lodash.isEmpty(this.originalFile) || !this.lodash.isNull(this.originalFile)){
                this.saveDocument()
            }
        },
        saveDocument(){
            // save-letter-document
            this.isSavingInfo = 'Saving...'
            const formData = new FormData();
            formData.append('letter_document', this.originalFile );
            const route = this.$router.resolve(
                {
                    name: 'save-letter-document',
                    params:{
                        letter: this.$route.params.letter_user,
                        client: this.$route.params.client,
                        team: this.$route.params.team,
                    }
                }
            );
            const $this = this;
            axios.post(route.href,formData).then(({data})=>{

                if(data.error != true){
                    toastr.success(data.message,'Success')
                    // $this.keyValue++
                    this.isSavingInfo = ''
                    $this.letter.documents.push(data.data);
                    $this.originalFile = null
                    $this.document = null

                }else{
                    this.isSavingInfo = ''
                    if(data.message){
                        toastr.error(data.message,'Error')
                        return;
                    }
                    toastr.error('An Error Occured While Updating Letter Documents')
                }
            })
        },
        downloadFile(url) {
            try {
                const blobUrl = URL.createObjectURL(url);

                const link = document.createElement('a');
                link.href = blobUrl;

                const fileName = url.split('/').pop();

                link.download = fileName;

                document.body.appendChild(link);

                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error('Error downloading file:', error);
            }
        },
        deleteDocument(index,id){
            this.isSavingInfo = 'Deleting...'
            const route = this.$router.resolve(
                {
                    name: 'delete-letter-document',
                    params:{
                        document:id,
                        letter: this.$route.params.letter_user,
                        client: this.$route.params.client,
                        team: this.$route.params.team,
                    }
                }
            );
            const $this = this;
            axios.post(route.href).then(({data})=>{

                if(data.error != true){
                    toastr.success(data.message,'Success')
                    // $this.keyValue++
                    this.isSavingInfo = ''
                    $this.letter.documents.splice(index,1);
                }else{
                    this.isSavingInfo = ''
                    if(data.message){
                        toastr.error(data.message,'Error')
                        return;
                    }
                    toastr.error('An Error Occured While Updating Letter Documents')
                }
            })
        },
        previewDocument(object){
            this.activeMedia = object
            this.openModal('#previewLetterMedia')
        }
    }
  };
</script>
<style>
    .display-box{
        border: 1px solid #e2e2e2;
        height: 32px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        padding: 0 10px;
        white-space: nowrap;
        width:max-content;
    }
</style>
